import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    fullScore = 100.0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.projAppraise.calcScore, {
        id,
        fullScore,
    }, options);
    if (error) return { error, status };
    return content || { id: '', fullScore: 100.0 };
};
